module.exports = __webpack_public_path__ + "static/img/swiper9.0a9b28f8.png";